import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Typography, Menu, MenuItem, ListItemIcon, Fade } from "@material-ui/core";
import EditIcon from "@material-ui/icons/BorderColorTwoTone";
import BlockIcon from "@material-ui/icons/RemoveCircleTwoTone";
import UnblockIcon from "@material-ui/icons/AddCircleTwoTone";
import ActivateIcon from "@material-ui/icons/BeenhereTwoTone";
import DeleteIcon from "@material-ui/icons/DeleteTwoTone";

import translate from "../i18n/Translator";
import { User } from "../model/User";
import { AppContext } from "../context/AppContext";

interface UserMenuProps {
    user: User;
    tenantId?: string;
    customerId?: string;
    anchor: HTMLElement | null;
    onClose(): any;
    onActivated(): any;
    onBlock(): any;
    onUnblock(): any;
    onDelete(): any;
}

export default function UserMenu(props: UserMenuProps) {
    const context = useContext(AppContext);
    const itself = props.user.id === context.session?.user.id;

    return (
        <Menu
            id="tenants-item"
            anchorEl={props.anchor}
            keepMounted
            onClose={props.onClose}
            open
            TransitionComponent={Fade}
        >
            {itself &&
                <MenuItem button component={Link} to="/profile" onClick={props.onClose} dense>
                    <ListItemIcon>
                        <EditIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.edit")}</Typography>
                </MenuItem>
            }
            {!itself && context.isGrantedAny(["UsersUpdate", "TenantsUsersUpdate", "CustomersUsersUpdate"]) &&
                <MenuItem button component={Link} to={`${(props.tenantId ? `/tenants/${props.tenantId}` :
                    (props.customerId ? `/customers/${props.customerId}` : context.session?.customer?.id ? `/customers/${context.session?.customer?.id}` : ""))}/users/${props.user.id}/edit`}
                    onClick={props.onClose} dense>
                    <ListItemIcon>
                        <EditIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.edit")}</Typography>
                </MenuItem>
            }
            {!itself && !props.user.blocked && props.user.signup_code && context.isGrantedAny(["UsersUpdate", "TenantsUsersUpdate", "CustomersUsersUpdate"]) &&
                <MenuItem button onClick={() => props.onActivated()} dense>
                    <ListItemIcon>
                        <ActivateIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.activate")}</Typography>
                </MenuItem>
            }
            {!itself && !props.user.blocked && context.isGrantedAny(["UsersBlock", "TenantsUsersBlock"]) &&
                <MenuItem button onClick={props.onBlock} dense>
                    <ListItemIcon>
                        <BlockIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.block")}</Typography>
                </MenuItem>
            }
            {!itself && props.user.blocked && context.isGrantedAny(["UsersBlock", "TenantsUsersBlock"]) &&
                <MenuItem button onClick={props.onUnblock} dense>
                    <ListItemIcon>
                        <UnblockIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">{translate("buttons.unblock")}</Typography>
                </MenuItem>
            }
            {!itself && context.isGrantedAny(["UsersDelete", "TenantsUsersDelete", "CustomersUsersDelete"]) &&
                <MenuItem button onClick={props.onDelete} dense>
                    <ListItemIcon>
                        <DeleteIcon fontSize="small" color="error" />
                    </ListItemIcon>
                    <Typography variant="inherit" color="error">{translate("buttons.delete")}</Typography>
                </MenuItem>
            }
        </Menu>
    );

}